import { Flex, Text } from '@chakra-ui/react';

import { BellSlash, Check } from '@enterprise/ui';

import type { NotificationEmptyProps } from './types/notification-empty.props';

export const NotificationEmpty = ({ tab }: NotificationEmptyProps) => {
  const renderContent = () => {
    if (tab === 'errors') {
      return (
        <>
          <Flex
            align="center"
            bg="gray.200"
            color="gray.600"
            h={16}
            justify="center"
            rounded="full"
            w={16}>
            <BellSlash size="xl" />
          </Flex>
          <Text color="gray.500">No errors</Text>
        </>
      );
    }

    if (tab === 'unread') {
      return (
        <>
          <Flex
            align="center"
            bg="gray.200"
            color="gray.600"
            h={16}
            justify="center"
            rounded="full"
            w={16}>
            <BellSlash size="xl" />
          </Flex>
          <Text color="gray.500">No unread notifications</Text>
        </>
      );
    }

    return (
      <>
        <Flex
          align="center"
          bg="gray.200"
          color="gray.600"
          h={16}
          justify="center"
          rounded="full"
          w={16}>
          <Check size="xl" />
        </Flex>
        <Text color="gray.500">You're all caught up</Text>
      </>
    );
  };

  return (
    <Flex
      align="center"
      direction="column"
      gap={2}
      justify="center"
      minH="120px"
      p={6}>
      {renderContent()}
    </Flex>
  );
};
